import { mediaQueriesBP } from "@dillon/Utilities/variables";
import { viewStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsView";
import { css } from "styled-components";

styles.rightColumnGridItemHidden = {
    ...styles.rightColumnGridItemHidden,
    css: css`
        ${styles.rightColumnGridItemHidden?.css}

        ${mediaQueriesBP.minMD} {
            height: 100%;

            & > div {
                height: 100%;
            }
        }
    `,
}